import { INoteData } from '../../components/ingestion/IngestedTree'
import { IngestionContext } from './types'
import {
  createNoteNode as createNoteNodeUtil,
  createShortResponse as createShortResponseUtil,
  createNodeList as createNodeListUtil,
  createSkillsList as createSkillsListUtil,
} from '../nodeCreationHelpers'
import { IQuestionDataBase } from '../../components/ingestion/IngestionQuestions'

export const createSkillsList = createSkillsListUtil
export const createNodeList = createNodeListUtil

export function createNoteNode(
  { value, ...rest }: INoteData,
  context: IngestionContext,
) {
  return createNoteNodeUtil({
    value: context.stringContentPostProcessing(value),
    ...rest,
  })
}

export function createShortResponse(
  {
    description,
    ...rest
  }: Partial<IQuestionDataBase> & { description: string },
  context: IngestionContext,
) {
  return createShortResponseUtil({
    description: context.stringContentPostProcessing(description),
    ...rest,
  })
}
